import React from 'react'
import { Modal } from 'antd'
import { close_icon, CorrectTick } from '../../assets/images'

const SuccessModal = ({ title, para1, para2, visible, close }) => {
  const modalIcon = <img src={CorrectTick} alt='mail_icon' className='inline-block h-14 w-14 my-6' />
  const closeIcon = <img src={close_icon} alt='close_icon' style={{ display: 'inline-block' }} />

  return (
    <Modal
      visible={visible}
      footer={null}
      centered
      bodyStyle={{
        height: '280px',
        textAlign: 'center',
      }}
      width='631px'
      onCancel={close}
      closeIcon={closeIcon}
    >
      {modalIcon}
      <h1 className='mb-0 text-gray-700 text-xl font-semibold'>{title}</h1>
      <p className='mb-0 mt-3 text-base text-gray-600'>{para1}</p>
      <p className='mb-0 mt-2 text-base text-gray-600 mx-12'>{para2}</p>
    </Modal>
  )
}

export default SuccessModal
